<script setup lang="ts">
import {
  Column,
  Columns,
  Stack,
  Typography,
} from '@apparatix/library/core';

type Props = {
  leftColHeader?: string;
  rightColHeader?: string;
}

const props = defineProps<Props>();
</script>
<template>
  <Columns>
    <Column>
      <Stack :gap="5">
        <div v-if="Boolean(props.leftColHeader)" class="flex items-center w-full pb-3 lg:pb-4 border-b border-[var(--p-content-border-color)]">
          <Typography variant="form-heading">
            {{ props.leftColHeader }}
          </Typography>
        </div>
        <slot name="left-col" />
      </Stack>
    </Column>
    <Column>
      <Stack :gap="5">
        <div v-if="Boolean(props.rightColHeader)" class="flex items-center w-full pb-3 lg:pb-4 border-b border-[var(--p-content-border-color)]">
          <Typography variant="form-heading">
            {{ props.rightColHeader }}
          </Typography>
        </div>
        <slot name="right-col" />
      </Stack>
    </Column>
  </Columns>
</template>
